import GameCard from '@/stories/molecules/cards/gameCard/GameCard';
import { GameCardProps } from '@/stories/molecules/cards/gameCard/interface';

const FIRST_VISIBLE_GRID_CARDS = 4;

function GameCardComponent({ game, index = 0 }: Readonly<GameCardProps>) {
  return (
    <GameCard
      game={game}
      index={index}
      priority={index < FIRST_VISIBLE_GRID_CARDS}
      categorySelected=""
      showFavoriteButton
      showPlayButton
      variant="default"
    />
  );
}

export default GameCardComponent;
